import { Email, PictureAsPdf } from '@mui/icons-material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Popover, Stack, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useRightSidebar } from 'src/layouts/right-side-bar/rightSidebarProvider';
import HttpServices from 'src/services/httpService';
import { reportModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import ScheduledReportView from './scheduledReportView.component';
import SendAsEmailComponent from './sendAsEmail.component';
import { useTranslation } from 'react-i18next';

const ReportActionPopup = ({
  open,
  anchorEl,
  onClose,
  serviceName,
  startDate,
  endDate,
  viewBy,
  connectedProfileId = -1,
  reportId,
  subReportId = 0,
  currReportData,
  isCustomReport = false,
  fetchCustomReports = () => {}, // Default empty function added here
}) => {
  const { t: translate } = useTranslation();
  let currentBrandId = CommonHelper.GetCurrentBrandId();
  const { showRightSidebar } = useRightSidebar();
  const { showToast } = useToaster();

  const { enqueueSnackbar } = useSnackbar();
  const getExportReport = (type) => {
    const formBody = {
      from: startDate,
      to: endDate,
      view_by: viewBy,
      type: type,
      report_id: reportId,
      sub_report_id: subReportId,
      service_name: serviceName,
      connected_profile_id: connectedProfileId,
      brand_id: currentBrandId,
      is_custom_report: isCustomReport,
    };

    enqueueSnackbar(`${translate('report.generating_report')}...`, { variant: 'info' });

    const successCallback = (data) => {
      if (data?.report_url) {
        const link = document.createElement('a');
        link.href = data.report_url;
        link.download = isCustomReport
          ? currReportData.custom_report_name
          : currReportData.report_display_name
          ? currReportData.report_display_name
          : currReportData.card_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        enqueueSnackbar(`${translate('report.report_generated_successfully')}!`, { variant: 'success' });
      }
    };

    const failureCallback = (message) => {
      enqueueSnackbar(message || `${translate('report.failed_to_generate_report')}`, { variant: 'error' });
    };

    const getProps = {
      url: reportModuleURL.exportReport,
      body: formBody,
      successCallback,
      failureCallback,
    };

    HttpServices.Post(getProps);
  };
  const handleDeleteCustomReportCard = () => {
    const formBody = {
      report_card_id: subReportId,
      custom_report_id: reportId,
    };

    const successCallback = (data, message) => {
      showToast(message, 's');
      fetchCustomReports();
      onClose();
    };

    const failureCallback = (message) => {
      showToast(message, 'e');
    };

    const getProps = {
      url: reportModuleURL.deleteCustomReportCard,
      body: formBody,
      successCallback,
      failureCallback,
    };

    HttpServices.Post(getProps);
  };

  const handleOpenPost = () => {
    let data = {
      content: sideBarView,
    };
    showRightSidebar(data);
    onClose();
  };

  const sideBarView = () => {
    let emailDetails = {
      serviceName: serviceName,
      startDate: startDate,
      endDate: endDate,
      viewBy: viewBy,
      connectedProfileId: connectedProfileId,
      reportId: reportId,
      subReportId: subReportId,
      currReportData,
      isCustomReport,
      onClose,
    };
    return <SendAsEmailComponent {...emailDetails} />;
  };
  const handleOpenSceduled = () => {
    let data = {
      content: sideBarSheduledView,
    };
    showRightSidebar(data);
    onClose();
  };

  const sideBarSheduledView = () => {
    let emailDetails = {
      serviceName: serviceName,
      startDate: startDate,
      endDate: endDate,
      viewBy: viewBy,
      connectedProfileId: connectedProfileId,
      reportId: reportId,
      subReportId: subReportId,
      currReportData,
      isCustomReport,
    };
    return <ScheduledReportView {...emailDetails} />;
  };

  // const getExportReport = (type) => {
  //     setLoading(true);
  //     const formBody = {
  //         from: startDate,
  //         to: endDate,
  //         view_by: viewBy,
  //         type: type,
  //         report_id: reportId,
  //         sub_report_id: subReportId,
  //         service_name: serviceName,
  //         connected_profile_id: connectedProfileId,
  //     };

  //     const getProps = {
  //         url: reportModuleURL.exportReport,
  //         body: formBody,
  //         successCallback,
  //         failureCallback,
  //     };
  //     HttpServices.Post(getProps);
  // };

  return (
    <>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            width: 230,
            borderRadius: 1,
            boxShadow: 3,
            //display:'none',
          },
        }}
      >
        <Box sx={{ p: 1, textAlign: 'center' }}>
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{
              cursor: 'pointer',
              padding: '8px 16px',
              borderRadius: 1,
              '&:hover': { backgroundColor: 'action.hover' },
              mb: 1,
            }}
            onClick={() => getExportReport('PDF')}
          >
            <PictureAsPdf color="action" />
            <Typography variant="body1">{translate('report.download_as_pdf')}</Typography>
          </Stack>
          {/* <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            sx={{
                                cursor: 'pointer',
                                padding: '8px 16px',
                                borderRadius: 1,
                                '&:hover': { backgroundColor: 'action.hover' },
                                mb: 1,
                            }}
                            onClick={() => getExportReport("PNG")}
                        >
                            <Image color="action" />
                            <Typography variant="body1">Download as PNG</Typography>
                        </Stack> */}
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{
              cursor: 'pointer',
              padding: '8px 16px',
              borderRadius: 1,
              '&:hover': { backgroundColor: 'action.hover' },
            }}
            onClick={handleOpenPost}
          >
            <Email color="action" />
            <Typography variant="body1">{translate('report.send_as_email')}</Typography>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{
              cursor: 'pointer',
              padding: '8px 16px',
              borderRadius: 1,
              '&:hover': { backgroundColor: 'action.hover' },
            }}
            onClick={handleOpenSceduled}
          >
            <ScheduleIcon color="action" />
            <Typography variant="body1">{translate('report.schedule')}</Typography>
          </Stack>
          {isCustomReport && subReportId !== 0 && (
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{
                cursor: 'pointer',
                padding: '8px 16px',
                borderRadius: 1,
                '&:hover': { backgroundColor: 'error.light' },
                color: 'error.main',
              }}
              onClick={handleDeleteCustomReportCard}
            >
              <DeleteIcon />
              <Typography variant="body1">{translate('custom_report.delete')}</Typography>
            </Stack>
          )}
        </Box>
      </Popover>
    </>
  );
};

export default ReportActionPopup;
